import { render, staticRenderFns } from "./Register_Mobile.vue?vue&type=template&id=664e3e5d&scoped=true&"
import script from "./Register_Mobile.vue?vue&type=script&lang=js&"
export * from "./Register_Mobile.vue?vue&type=script&lang=js&"
import style1 from "./Register_Mobile.vue?vue&type=style&index=1&id=664e3e5d&prod&lang=css&"
import style2 from "./Register_Mobile.vue?vue&type=style&index=2&id=664e3e5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e3e5d",
  null
  
)

export default component.exports